export default __webpack_public_path__ + "static/media/company-fr.fd3d6434.png";